import * as UI from '@brewlogix/blx-ui'
import { Button, Icon } from '@chakra-ui/react'
import { QuestionMarkCircleIcon } from '@heroicons/react/solid'
import classNames from 'classnames'
import * as React from 'react'
import { useLocationSlugStore } from 'src/features/locations/state/useLocationSlugStore'
import { IuseLinkTabsStore } from 'src/hooks/createLinkTabsStore'
import { IuseStickyNav } from 'src/hooks/createStickyNavStore'
import parseEnvSubdomain from 'src/util/helpers/parseEnvSubdomain'

export type TabConfigItem = {
    id: number
    text: string
    tag: string
    extra?: string
    action: () => void
}

interface ILinkTabsRow {
    tabs: TabConfigItem[]
    tabStore: IuseLinkTabsStore
    stickyStore: IuseStickyNav
    brandId?: string
}
interface IRoundedLink {
    tab: TabConfigItem
}

const LinkTabsRow: React.FC<ILinkTabsRow> = ({ tabs, tabStore, stickyStore, brandId }) => {
    const { setSelectedElement, selectedElement, linkTabsConfig } = tabStore
    const setIsThisYourBreweryModalIsOpen = useLocationSlugStore(
        (state) => state.setIsThisYourBreweryModalIsOpen
    )
    const { isTabsSticky } = stickyStore
    const subdomain = parseEnvSubdomain()
    React.useEffect(() => {
        setSelectedElement(tabs[0].tag)
    }, [])

    const BrewNumberRow = ({ num, isSelected }: { num: string; isSelected: boolean }) => {
        return (
            <div className=' ml-2 flex flex-row items-center space-x-2'>
                <span
                    className={classNames(
                        'flex-nowrap rounded-full bg-green-200 px-2 py-px text-sm  text-green-700',
                        !isSelected && 'bg-gray-100 text-gray-300'
                    )}
                >
                    {num}
                </span>
            </div>
        )
    }

    const RoundedLink: React.FC<IRoundedLink> = ({ tab }) => {
        const { text, action, extra, tag } = tab
        const isOn = tag === selectedElement
        return (
            <UI.Button
                theme={isOn ? 'success' : 'light'}
                customClasses={classNames(
                    'rounded-full p-3 py-1  xl:p-4 xl:py-2 h-8 md:h-12 flex-nowrap flex items-center text-sm xl:text-base flex-shrink-0',
                    !isOn && 'text-gray-300 '
                )}
                size='sm'
                onClick={() => {
                    // console.log('action for hash', text)
                    setSelectedElement(tag)
                    // setIsSticky(true)
                    setTimeout(() => {
                        action()
                    }, 50)
                }}
                label={text}
            >
                {extra && <BrewNumberRow num={extra} isSelected={isOn} />}
            </UI.Button>
        )
    }

    return (
        <div
            className={classNames(
                'flex w-full flex-col items-center justify-between bg-white py-2 xl:flex-row ',
                isTabsSticky && ' border-y-gray-100 lg:border-y-px '
            )}
        >
            <div className='mx-auto flex w-full max-w-[1440px] flex-col items-start justify-between overflow-x-scroll px-4 scrollbar-hide xl:flex-row xl:items-center xl:px-20'>
                <div className='flex flex-row space-x-2 scrollbar-hide lg:overflow-x-visible'>
                    {tabs.map((tab) => (
                        <RoundedLink tab={tab} key={tab.tag} />
                    ))}
                </div>

                <Button
                    variant='link'
                    display={isTabsSticky && 'hidden'}
                    className='mt-0 flex flex-nowrap px-0'
                    onClick={() => {
                        setIsThisYourBreweryModalIsOpen(true)
                    }}
                >
                    <Icon as={QuestionMarkCircleIcon} boxSize={5} marginRight={1} />
                    Is This Your Brewery?
                </Button>
            </div>
        </div>
    )
}

export default LinkTabsRow
